var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconDoubleQuotation = function SvgIconDoubleQuotation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_double_quotation_svg__a)",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.002 7.475c0-3.982 2.925-6.349 4.746-7.439.231-.137.48.148.305.35a9.213 9.213 0 0 0-1.678 2.737 4.759 4.759 0 0 1 1.274-.174c2.567 0 4.647 2.026 4.647 4.526S7.212 12 4.645 12-.002 9.975-.002 7.475ZM10.705 7.475c0-3.982 2.925-6.349 4.746-7.44.231-.136.48.15.305.352a9.212 9.212 0 0 0-1.678 2.735 4.758 4.758 0 0 1 1.274-.173C17.92 2.95 20 4.977 20 7.475c0 2.497-2.08 4.525-4.647 4.525s-4.647-2.026-4.647-4.525Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_double_quotation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-180 10 6)",
    d: "M0 0h20v12H0z"
  })))));
};
export default SvgIconDoubleQuotation;